module.exports = __webpack_public_path__ + "static/media/company-Ban.1d5d6956.svg";